var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Google icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4200_30463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3711 10.5352V14.5711H17.9533C17.7123 15.8753 16.9815 16.9796 15.883 17.7203V20.3374H19.2345C21.1971 18.5213 22.3276 15.8464 22.3276 12.6691C22.3276 11.93 22.2621 11.2181 22.1393 10.5352H12.3711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4200_30463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60938 26.1325H28.0892V4.73828H6.60938V26.1325Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4200_30463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 14,
    width: 17,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10156 14.4141V17.117C4.80804 20.527 8.31594 22.8648 12.3695 22.8648C15.1698 22.8648 17.5177 21.9315 19.2329 20.3376L15.8814 17.7205C14.9528 18.3465 13.7649 18.7157 12.3695 18.7157C9.6682 18.7157 7.38252 16.8811 6.56638 14.4141H3.10156Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4200_30463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.66016 28.6607H24.9962V8.61719H-2.66016V28.6607Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4200_30463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 5,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10255 7.75C2.40049 9.15846 2 10.7515 2 12.4352C2 14.119 2.40049 15.7112 3.10255 17.1197L6.56737 14.4167C6.35994 13.7915 6.24267 13.123 6.24267 12.4352C6.24267 11.7475 6.35994 11.0789 6.56737 10.4522V7.75H3.10255Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4200_30463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.76172 22.9163H12.3298V1.95312H-3.76172V22.9163Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4200_30463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 17,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10156 7.74861L6.56638 10.4508C7.38252 7.98536 9.6682 6.14995 12.3695 6.14995C13.8925 6.14995 15.2591 6.67641 16.3346 7.71089L19.3095 4.71741C17.5129 3.03448 15.165 2 12.3695 2C8.31594 2 4.80804 4.33861 3.10156 7.74861Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4200_30463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.66016 16.2458H25.0711V-3.79688H-2.66016V16.2458Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.6e6f6d3798a2000579464bb4b016233c.svg";
export { ForwardRef as ReactComponent };